import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum-slim';

/**
 * @param children
 * @constructor
 */
const RumProvider = ({ children }) => {
  useEffect(() => {
    setTimeout(() => {
      const replayUrl = window?.QuantumMetricAPI?.getReplay();

      const links = {
        ...(replayUrl ? { qm: replayUrl } : {}),
      };

      datadogRum.addRumGlobalContext('links', links);
    }, 2000);
  }, []);
  return children;
};

export default RumProvider;
